const buyContractAddress = "0xa670c1b6eb08502Ab1bf58B63338964D06a515fa" /// binance market

export default buyContractAddress;